export default __webpack_public_path__ + "9c6217f8e0cda82b1307c648cd785a00.svg";